module.exports = __webpack_public_path__ + "img/21.f21b1dab.jpg";